// A tab opened before a deploy still lazy-loads route chunks by their old hashed URL, which no
// longer exists after the deploy. Reload once so the page picks up the current index.html and
// bundle. Once per tab session, so a genuine network failure surfaces instead of reload-looping.
//
// Preventing `vite:preloadError` makes Vite's preload helper resolve the `import()` to undefined
// instead of rejecting, so code that unwraps the module (`({ default }) => …`, `m.PreBindFarmUW`)
// throws in the moment before the reload lands. Those errors are doomed and say nothing about the
// code; Sentry's beforeSend drops them while `isStaleChunkReloadPending()` (#36444).
export const STALE_CHUNK_RELOAD_KEY = 'staff-fe:stale-chunk-reloaded';

// How long after triggering the reload errors still count as doomed. The reload does not always
// land: pages with unsaved edits (e.g. policy) register a beforeunload "Leave site?" prompt, and if
// the user picks Stay the tab keeps running. Without an expiry every later error in that tab would
// be dropped, so after this window errors are reported again.
export const STALE_CHUNK_RELOAD_PENDING_MS = 10_000;

let staleChunkReloadStartedAt = null;

export const isStaleChunkReloadPending = () =>
  staleChunkReloadStartedAt !== null && Date.now() - staleChunkReloadStartedAt < STALE_CHUNK_RELOAD_PENDING_MS;

// Test-only: the timestamp is module state that a real page only ever leaves by reloading.
export const resetStaleChunkReloadPending = () => {
  staleChunkReloadStartedAt = null;
};

export function reloadOnStaleChunk({ reload = () => window.location.reload() } = {}) {
  const onPreloadError = (event) => {
    if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) {
      return;
    }
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, '1');
    staleChunkReloadStartedAt = Date.now();
    event.preventDefault();
    reload();
  };
  window.addEventListener('vite:preloadError', onPreloadError);
  return () => window.removeEventListener('vite:preloadError', onPreloadError);
}
